import {NavigateFunction} from 'react-router-dom';
import {savaquanFetchJson} from './http.service';
import {CompanyPlanDto, PlanChoiceDto} from '../dtos/company-plan.dto';

const baseUrl = `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/billing`;

/**
 * SQ-415: the company's own plan. Card details never pass through here:
 * the first plan is bought on Stripe Checkout and the payment method,
 * receipts and cancelling are in Stripe's portal; these calls return their
 * URL and the page goes there. Every charge carries a fresh request id per
 * press, so a retried request never charges twice.
 */
export const getCompanyPlan = (navigate: NavigateFunction, refresh = false) =>
  savaquanFetchJson<CompanyPlanDto>(`${baseUrl}${refresh ? '?refresh=true' : ''}`, {navigate});

const post = <T>(navigate: NavigateFunction, path: string, body?: unknown) =>
  savaquanFetchJson<T>(`${baseUrl}${path}`, {
    navigate,
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: body === undefined ? undefined : JSON.stringify(body),
  });

export const newRequestId = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export const startCheckout = (navigate: NavigateFunction, choice: PlanChoiceDto) =>
  post<{url: string}>(navigate, '/checkout', {...choice, requestId: newRequestId()});

export const openBillingPortal = (navigate: NavigateFunction) =>
  post<{url: string}>(navigate, '/portal');

export const changePlan = (navigate: NavigateFunction, choice: PlanChoiceDto) =>
  post<CompanyPlanDto>(navigate, '/plan', {...choice, requestId: newRequestId()});

export const addEstimates = (navigate: NavigateFunction, count: number) =>
  post<CompanyPlanDto>(navigate, '/added-estimates', {count, requestId: newRequestId()});
